import React, { useEffect, useState } from "react";
import GridLines from "@/components/site/GridLines";

const NAV = [
  { label: "Introducing Renaflex", href: "#introducing" },
  { label: "Why Renaflex", href: "#why" },
  { label: "Our Ranges", href: "#ranges" },
  { label: "Applications", href: "#applications" },
  { label: "Sustainability", href: "#sustainability" },
  { label: "Enquiry", href: "#enquiry" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <header className="rf-header" data-testid="site-header">
        <div className="rf-header__inner">
          <GridLines tone="light" />
          <button
            type="button"
            className="rf-burger"
            aria-label="Open menu"
            aria-expanded={open}
            onClick={() => setOpen(true)}
            data-testid="menu-open"
          >
            <span />
            <span />
            <span />
          </button>

          <a href="#top" className="rf-header__logo" data-testid="site-logo">
            <img src="/assets/logo.svg" alt="Renaflex — Fibre Cement Board, by Renacon" />
          </a>

          <div className="rf-header__cta">
            <a href="#enquiry" className="rf-btn rf-btn--green" data-testid="header-enquiry">
              ENQUIRY
            </a>
          </div>

          <a
            href="#enquiry"
            className="rf-header__wa"
            aria-label="Enquiry"
            data-testid="header-enquiry-mobile"
          >
            <svg viewBox="0 0 24 24" width="22" height="22" fill="#fff" aria-hidden="true">
              <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2Zm5.8 14.07c-.24.68-1.42 1.31-1.96 1.36-.55.05-1.06.24-3.57-.75-2.51-.99-4.1-3.56-4.22-3.73-.12-.16-1-1.33-1-2.54 0-1.21.63-1.8.86-2.05.23-.25.5-.31.67-.31.17 0 .34 0 .49.01.16.01.37-.06.58.44.2.5.7 1.72.76 1.85.06.12.1.27.02.43-.08.16-.12.26-.24.4-.12.14-.26.31-.37.42-.12.12-.25.25-.11.5.14.25.62 1.03 1.34 1.67.92.82 1.7 1.08 1.94 1.2.24.12.38.1.52-.06.14-.16.6-.7.76-.94.16-.24.32-.2.54-.12.22.08 1.4.66 1.64.78.24.12.4.18.46.28.06.1.06.6-.18 1.28Z" />
            </svg>
          </a>
        </div>
      </header>

      <div
        className={`rf-drawer${open ? " is-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!open}
        data-testid="menu-drawer"
      >
        <div className="rf-drawer__bar">
          <img className="rf-drawer__logo" src="/assets/logo.svg" alt="Renaflex" />
          <button
            type="button"
            className="rf-drawer__close"
            aria-label="Close menu"
            onClick={() => setOpen(false)}
            data-testid="menu-close"
          >
            <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
              <path d="M4 4l16 16M20 4L4 20" stroke="#fff" strokeWidth="1.6" fill="none" />
            </svg>
          </button>
        </div>
        <nav className="rf-drawer__nav">
          {NAV.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </>
  );
}
